import React, {PureComponent} from 'react';
import Api from "../../../utils/api_calls";
import * as actionTypes from "../../../store/actions";
import store from "../../../store/store";
import Dotdotdot from "react-dotdotdot/src/index";
import common from "../../../utils/common";
import AssetThumbnail from "../../AssetThumbnail/AssetThumbnail";
import "./GridItem.scss";
import PlayIcon from "../../../ui/PlayIcon/PlayIcon";
import ConfigurationHelper from "../../../configuration/ClientConfigurationHelper";
import AmbassadorHelper from "../../../utils/AmbassadorHelper";

const RoundedPlayIcon = () => <span className="rounded-play-icon">
        <PlayIcon />
    </span>;

const MoreProductsMessage = ({totalProducts}) => (
    <li className="more-products">
        <span>
        +{totalProducts}
            <br/>
            MORE
        </span>
    </li>
);

class GridItem extends PureComponent {
    state = {
        products: [],
        ambassador: null
    }

    componentDidMount() {
        this.getAmbassador();
        this.setState({products: this.props.asset?.products || []});
    }

    getAmbassador = () => {
        const that = this;
        const {user_id} = this.props.asset;
        if(!user_id || !ConfigurationHelper.isAmbassadorProgramEnabled()) return;
        Api.ambassador(user_id).then(response => {
            const ambassadorResponse = (response && response.data && response.data.user_id) ? response.data : null;
            that.setState({
                ambassador: ambassadorResponse
            });

        });
    }

    getProductsMarkup = () => {
        const {products} = this.state;
        const totalProducts = products.length;
        const productsToShow = products.slice(0, 3);
        const productsToShowMarkup = productsToShow.map(this.getMarkupFromProduct);
        if (totalProducts > 3) {
            return [
                productsToShowMarkup,
                ...[<MoreProductsMessage key="more" totalProducts={totalProducts - 3}/>]
            ];
        }
        return productsToShowMarkup;
    }
    updateAsset = () => {
        const {asset} = this.props;
        store.dispatch({
            type: actionTypes.UPDATE_ASSET,
            asset
        });
    }
    getMarkupFromProduct = (product) => {
        const {product_id, title, image} = product;
        return <li key={product_id}>
            <img  src={image} alt={title}/>
        </li>;
    }
    goToAssetPage = (e) => {
        const {redirect} = this.props;
        if (!redirect) {
            e.preventDefault();
            e.stopPropagation();
            this.updateAsset();
        }
        return e;
    }
    getAmbassadorUrl = () => {
        if(this.state.ambassador)
            return common.generateAmbassadorUrl(this.state.ambassador);
        else
            return "";
    }
    render() {
        const {asset,
            lazyLoadingThumbnails,
            enableAmbassador,
            playing,
            maxDescriptionLines,
            carouselItem,
            dataTestid
        } = this.props;
        const {ambassador} = this.state;
        const assetUrl = common.generateAssetUrl(asset);
        const showPlayIcon = !common.isPhoto(asset);
        const products = this.getProductsMarkup();
        const elementSize = carouselItem ? "col-xs-12" : "col-xl-3 col-lg-4 col-sm-6 col-12";
        const ambassadorUrl = this.getAmbassadorUrl();
        return (
            <div data-testid={dataTestid}  className={elementSize+ " grid-item"}>
                <div className={"p-2 item-box " + (playing ? "watching" : "")}>
                    <a href={assetUrl} onClick={() =>(this.goToAssetPage(),window.location.href = assetUrl)} className={`pb-0`}>
                        <div className="image-container">
                            <AssetThumbnail thumbnailUrl={common.getThumbnail(asset)} alt={asset.title}
                                            lazyLoadingThumbnails={lazyLoadingThumbnails}
                                            isPhoto={common.isPhoto(asset)}/>
                            {showPlayIcon && <RoundedPlayIcon/>}
                        </div>
                        <Dotdotdot className={"item-title"} clamp={2}>
                            <h3>{asset.title}</h3>
                        </Dotdotdot>
                    </a>
                    { (enableAmbassador && ambassador && ambassador.first_name) &&
                    <a href={ambassadorUrl} className="author">{ AmbassadorHelper.getDisplayNameFromApi(ambassador) }</a>}
                    <a tabIndex={"-1"} href={assetUrl} onClick={() =>(this.goToAssetPage(),window.location.href = assetUrl)} className={"description-products"}>
                        { (maxDescriptionLines > 0) &&<Dotdotdot clamp={maxDescriptionLines}>
                            <p>{asset.description}</p>
                        </Dotdotdot>}
                        <div className="products">
                            <ul>{products}</ul>
                        </div>
                    </a>
                </div>
            </div>
        );
    }
}

GridItem.defaultProps = {
    redirect: true,
    enableAmbassador: ConfigurationHelper.isAmbassadorProgramEnabled(),
    carouselItem: false,
    lazyLoadingThumbnails: true,
    maxDescriptionLines: 4
};

export default GridItem;
